import { i18n } from '../lang'

export const promoTagListColumns = [
  { type: 'id', custom: { width: '48' } },
  { type: 'promo_code', custom: { width: '78' } },
  { type: 'start_at', custom: { width: '135' } },
  { type: 'end_at', custom: { width: '135' } },
  { type: 'category_slugs', title: i18n.t('table.categories'), custom: { width: '120' } },
  { type: 'brand_slugs', title: i18n.t('table.brands'), custom: { width: '120' } },
  { type: 'currently_discounted', title: i18n.t('table.promotionApplies') },
  { type: 'min_price_usd', custom: { width: '78' } },
  { type: 'max_price_usd', custom: { width: '78' } },
  { type: 'title', custom: { width: '160' }, isLocalized: true },
  { type: 'priority', custom: { width: '65' } },
  { type: 'terms', custom: { 'min-width': '120' }, isLocalized: true },
  { type: 'whitelist_product_ids', title: i18n.t('table.includeProductIds'), custom: { 'min-width': '136' } },
  { type: 'blacklist_product_ids', title: i18n.t('table.excludeProductIds'), custom: { 'min-width': '136' } },
  { type: 'action', custom: { width: '58', align: 'center', fixed: 'right' } },
]

export const getDefaultPromoCodeDetail = () => ({
  enabled: 1,
  end_at: '',
  category_slugs: [],
  brand_slugs: [],
  id: null,
  priority: 1,
  min_price_usd: 0,
  max_price_usd: 0,
  promo_code: '',
  currently_discounted: ['Discounted Items', 'Regular Price Items'],
  start_at: '',
  store_id: null,
  terms: '',
  terms_th_th: null,
  terms_zh_cn: null,
  terms_zh_hk: null,
  title: null,
  title_th_th: null,
  title_zh_cn: null,
  title_zh_hk: null,
  whitelist_product_ids: '',
  blacklist_product_ids: '',
})

export const transformPromoCodeData = (data) => {
  const promotionApplyItems = {
    'Discounted Items': data.product_with_discount,
    'Regular Price Items': data.product_without_discount,
  }
  const currently_discounted = Object.keys(promotionApplyItems).filter(key => promotionApplyItems[key] === 1)
  return {
    ...data,
    whitelist_product_ids: data.whitelist_product_ids.join(','),
    blacklist_product_ids: data.blacklist_product_ids.join(','),
    currently_discounted,
  }
}
